import React from 'react'
import classNames from 'classnames'
import styles from './index.module.less'

const LEVELS = [
  { label: '1级', value: 1 },
  { label: '2级', value: 2 },
  { label: '3级', value: 3 },
  { label: '4级', value: 4 },
  { label: '5级', value: 5 },
  { label: '6级', value: 6 },
  { label: '7级', value: 7 },
  { label: '8级', value: 8 },
  { label: '9级', value: 9 },
]

export default ({ value = 1, onChange, disabled }) => {
  return <div className={styles.auditLevelSelect}>
    {LEVELS.map(item => <div
      key={item.value}
      onClick={() => {
        if (!disabled) {
          onChange(item.value)
        }
      }}
      className={classNames('auditLevelSelectItem', {
        active: item.value === value,
        disabled
      })}
    >{item.label}</div>)}
  </div>
}
